import { UserRoleName } from 'models'

export const notAllowedUserRolesBySection = {
  dashboard: [
    UserRoleName.PERSON_EDIT_ONLY
  ],
  projects: [
    UserRoleName.VIEW_PRODUCT_OWNER,
    UserRoleName.PERSON_EDIT_ONLY
  ],
  people: [
    UserRoleName.VIEW_PRODUCT_OWNER,
    UserRoleName.VIEW_CONTENT_OWNER,
    UserRoleName.PROJECT_MANAGER,
    UserRoleName.DEPARTMENT_MANAGER
  ],
  peopleCreate: [
    UserRoleName.VIEW_PRODUCT_OWNER,
    UserRoleName.VIEW_CONTENT_OWNER,
    UserRoleName.PROJECT_MANAGER,
    UserRoleName.DEPARTMENT_MANAGER,
    UserRoleName.PERSON_EDIT_ONLY
  ],
  brands: [
    UserRoleName.PERSON_EDIT_ONLY,
    UserRoleName.VIEW_CONTENT_OWNER,
    UserRoleName.PROJECT_MANAGER,
    UserRoleName.DEPARTMENT_MANAGER
  ],
  products: [
    UserRoleName.PERSON_EDIT_ONLY,
    UserRoleName.PROJECT_MANAGER,
    UserRoleName.DEPARTMENT_MANAGER
  ],
  agreements: [
    UserRoleName.OPERATOR_USER,
    UserRoleName.VIEW_CONTENT_OWNER,
    UserRoleName.VIEWER_OPERATOR_USER,
    UserRoleName.PERSON_EDIT_ONLY
  ],
  statistics: [
    UserRoleName.OPERATOR_USER,
    UserRoleName.VIEW_CONTENT_OWNER,
    UserRoleName.VIEWER_OPERATOR_USER,
    UserRoleName.PERSON_EDIT_ONLY
  ],
  actionHistory: [],
  viewers: [
    UserRoleName.OPERATOR_USER,
    UserRoleName.VIEW_CONTENT_OWNER,
    UserRoleName.VIEWER_OPERATOR_USER,
    UserRoleName.PERSON_EDIT_ONLY,
    UserRoleName.PROJECT_MANAGER,
    UserRoleName.DEPARTMENT_MANAGER
  ],
  userManagement: [
    UserRoleName.VIEW_PRODUCT_OWNER,
    UserRoleName.OPERATOR_USER,
    UserRoleName.VIEW_CONTENT_OWNER,
    UserRoleName.VIEWER_OPERATOR_USER,
    UserRoleName.PERSON_EDIT_ONLY,
    UserRoleName.PROJECT_MANAGER,
    UserRoleName.DEPARTMENT_MANAGER
  ],
  allowedEmail: [
    UserRoleName.VIEW_PRODUCT_OWNER,
    UserRoleName.OPERATOR_USER,
    UserRoleName.VIEW_CONTENT_OWNER,
    UserRoleName.VIEWER_OPERATOR_USER,
    UserRoleName.PERSON_EDIT_ONLY,
    UserRoleName.PROJECT_MANAGER,
    UserRoleName.DEPARTMENT_MANAGER
  ]
}
